import React from 'react';
import { GoalData } from './AddGoalFlow';
import { Icon } from '../Icon';
import './GoalConfirmation.css';

interface GoalConfirmationProps {
  data: GoalData;
  onConfirm: () => void;
  onEdit: (step: 'name' | 'type' | 'amount') => void;
  onBack: () => void;
  isSubmitting: boolean;
  currency: string;
}

// Символы валют
const currencySymbols: Record<string, string> = {
  'RUB': '₽',
  'USD': '$',
  'EUR': '€',
  'GBP': '£',
  'CNY': '¥',
  'JPY': '¥',
  'INR': '₹',
  'KRW': '₩',
  'TRY': '₺',
};

export const GoalConfirmation: React.FC<GoalConfirmationProps> = ({
  data,
  onConfirm,
  onEdit,
  onBack,
  isSubmitting,
  currency
}) => {
  const currencySymbol = currencySymbols[currency] || currency;

  const getGoalTypeLabel = () => {
    return data.type === 'with_amount' ? 'Цель с суммой' : 'Копилка';
  };

  return (
    <div className="goal-confirmation step-content">
      <div className="goal-confirmation__content">
        <div className="goal-confirmation__header">
          <button 
            className="goal-confirmation__back" 
            onClick={onBack}
            disabled={isSubmitting}
          >
            <Icon name="chevron_left" size={20} />
          </button>
          <div className="goal-confirmation__header-content">
            <h2 className="goal-confirmation__title">Подтверждение</h2>
            <p className="goal-confirmation__subtitle">
              Проверьте данные цели
            </p>
          </div>
        </div>

        <div className="goal-confirmation__preview">
          <div className="goal-preview-card neo-inset neo-static">
            <div className="goal-preview-card__icon">
              {data.icon ? (
                <Icon name={data.icon} size={48} />
              ) : (
                <Icon name="target" size={48} color="var(--color-primary)" />
              )}
            </div>
            <div className="goal-preview-card__name">{data.name}</div>
            <div className="goal-preview-card__type">{getGoalTypeLabel()}</div>
            
            {data.type === 'with_amount' && data.target_amount && (
              <div className="goal-preview-card__amount">
                {(data.target_amount || 0).toLocaleString()} {currencySymbol}
              </div>
            )}
            
            {data.type === 'piggybank' && (
              <div className="goal-preview-card__piggybank-info">
                Откладывайте столько, сколько хотите
              </div>
            )}
          </div>
        </div>

        <div className="goal-confirmation__details neo-raised neo-static">
          <button 
            className="goal-detail-item neo-raised neo-static" 
            onClick={() => onEdit('name')}
            disabled={isSubmitting}
          >
            <div className="goal-detail-item__label">Название</div>
            <div className="goal-detail-item__value">{data.name}</div>
            <div className="goal-detail-item__edit">✎</div>
          </button>

          <button 
            className="goal-detail-item neo-raised neo-static" 
            onClick={() => onEdit('type')}
            disabled={isSubmitting}
          >
            <div className="goal-detail-item__label">Тип</div>
            <div className="goal-detail-item__value">{getGoalTypeLabel()}</div>
            <div className="goal-detail-item__edit">✎</div>
          </button>

          {data.type === 'with_amount' && data.target_amount && (
            <button 
              className="goal-detail-item neo-raised neo-static" 
              onClick={() => onEdit('amount')}
              disabled={isSubmitting}
            >
              <div className="goal-detail-item__label">Целевая сумма</div>
              <div className="goal-detail-item__value">
                {(data.target_amount || 0).toLocaleString()} {currencySymbol}
              </div>
              <div className="goal-detail-item__edit">✎</div>
            </button>
          )}
        </div>
      </div>

      <div className="goal-confirmation__footer">
        <button
          className="goal-confirmation__submit"
          onClick={onConfirm}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Создание...' : 'Создать цель'}
        </button>
      </div>
    </div>
  );
};

